import React from "react"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import Tabs from '../Tabs/Tabs'
import ServiceLogBuilderTabContent from "./ServiceLogBuilderTabContent"
import ServiceLogBuilderErrors from "./ServiceLogBuilderErrors";
import { parseISO } from 'date-fns'

class ServiceLogBuilder extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      active_tab: this.props.active_tab || 'service-log-general',
      new_record: this.props.new_record,
      errors: this.props.errors || false,
      note_count: null,
      service_log: {
        status: this.props.service_log.status || "submitted",
        assigned_to: this.props.service_log.assigned_to || null,
        scheduled_at: parseISO(this.props.service_log.scheduled_at) || new Date(),
        setTimeOpen: this.props.service_log.start_time || this.props.service_log.end_time ? true : false,
        startTime: this.props.service_log.start_time ? new Date(this.props.service_log.start_time) : null,
        endTime: this.props.service_log.end_time ? new Date(this.props.service_log.end_time) : null,
        description: this.
        props.service_log.description || null,
        room: this.setRoom(),
        acknowledgedAt: this.props.service_log.acknowledged_at,
        startedAt: this.props.service_log.started_at,
        finishedAt: this.props.service_log.finished_at,
        products: this.props.service_log.products || [],
        createdAt: this.props.service_log.created_at
      },
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null,
      },
      image_group: this.props.image_group,
      loading: false,
    }

    this.formatCurrency = this.formatCurrency.bind(this);
    this.onChangeSetTimeOpen = this.onChangeSetTimeOpen.bind(this);
    this.onChangeAssignedTo = this.onChangeAssignedTo.bind(this);
    this.onChangeStartTime = this.onChangeStartTime.bind(this);
    this.onChangeEndTime = this.onChangeEndTime.bind(this);
    this.onChangeScheduledAt = this.onChangeScheduledAt.bind(this);
    this.onChangeNote= this.onChangeNote.bind(this);
    this.onChangeImageGroup = this.onChangeImageGroup.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this);
    this.onChangeRoom = this.onChangeRoom.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.updateNoteCount = this.updateNoteCount.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.onChangeTextInput = this.onChangeTextInput.bind(this);
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation()
          e.preventDefault()

          self.onSave()
        }
      }
    ]

    return(
      <div className="service-log-builder" ref="root">
        <Tabs tabs={this.tabs()} displayErrorMessage={(ServiceLogBuilderErrors.general(this.state.errors).length || ServiceLogBuilderErrors.room(this.state.errors).length || ServiceLogBuilderErrors.assigned_to(this.state.errors).length) ? true : false} />
        <div className="panel panel-form">
          <ServiceLogBuilderTabContent {...this.state}
            buttons={buttons}
            reservation_segment={this.props.reservation_segment}
            service_log_notes_path={this.props.service_log_notes_path}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            formatCurrency={this.formatCurrency}
            onChangeStatus={this.onChangeStatus}
            onChangeRoom={this.onChangeRoom}
            onChangeStartTime={this.onChangeStartTime}
            onChangeEndTime={this.onChangeEndTime}
            onChangeScheduledAt={this.onChangeScheduledAt}
            onChangeSetTimeOpen={this.onChangeSetTimeOpen}
            onChangeAssignedTo={this.onChangeAssignedTo}
            onChangeNote={this.onChangeNote}
            onChangeImageGroup={this.onChangeImageGroup}
            onChangeFlagged={this.onChangeFlagged}
            onChangeTextInput={this.onChangeTextInput}
            updateNoteCount={this.updateNoteCount}
           />

        </div>
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <LoadingSpinner show={this.state.loading} />
      </div>

    )
  }

  tabs() {
    var tabs =
      [
        {
          tabName: I18n.t('general'),
          targetName: 'service-log-general',
          classes: this.state.active_tab === 'service-log-general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ServiceLogBuilderErrors.general(this.state.errors).length,
        },
        {
          tabName: I18n.t('room'),
          targetName: 'room',
          classes: this.state.active_tab === 'room' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ServiceLogBuilderErrors.room(this.state.errors).length,
        },
        {
          tabName: I18n.t('assigned_to'),
          targetName: 'assigned_to',
          classes: this.state.active_tab === 'assigned_to' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ServiceLogBuilderErrors.assigned_to(this.state.errors).length,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'service-log-notes',
          classes: this.state.active_tab === 'service-log-notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    
    if (!this.props.new_record) {
      tabs.push({
        tabName: I18n.t('status_timeline'),
        targetName: 'status_timeline',
        classes: this.state.active_tab === 'status_timeline' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
      })
    }
    return tabs
  };

  onSave() {
    var self = this;
    this.setState({loading: true})
    $.ajax({
      type: self.props.new_record ? 'POST' : 'PATCH',
      url: self.props.form_action,
      data: {
        service_log: {
          assigned_to_id: self.state.service_log.assigned_to ? self.state.service_log.assigned_to.id : null,
          scheduled_at: self.state.service_log.scheduled_at,
          scheduled_start_time: self.state.service_log.startTime,
          scheduled_end_time: self.state.service_log.endTime,
          description: self.state.service_log.description,
          room_id: self.state.service_log.room ? self.state.service_log.room.id : null,
          reservation_segment_id: self.props.reservation_segment ? self.props.reservation_segment.id : null,
        },
        status: self.state.service_log.status,
        note: self.state.note_obj,
        image_group_images: self.state.image_group && self.state.image_group_images ? self.state.image_group.images.map(function(image) {return image.id}) : null,
      }
    }).done((data) => {
      self.setState({loading: false})
      if (parent && parent.refresh_data) {
        if (self.props.new_record == true) {
          parent.refresh_data(I18n.t('service_log_created_successfully'));
        } else {
          parent.refresh_data(I18n.t('service_log_saved_successfully'));
        }
      }

      if (parent && parent.hide_modal) {
        parent.hide_modal()
      }
    }).catch((data) => {
      if (data && data.responseJSON) {
        self.setState({errors: data.responseJSON, loading: false})
        $('.modal-body').scrollTop(0)
      }
    })
  }

  onChangeSetTimeOpen() {
    let log = Object.assign({}, this.state.service_log)
    if (log.setTimeOpen == false) {
      log.setTimeOpen = true
    } else {
      log.setTimeOpen = false
    }
    this.setState({
      service_log: log,
    })
  }

  onChangeStartTime(time) {
    let log = Object.assign({}, this.state.service_log)
    log.startTime = time
    this.setState({
      service_log: log,
    })
  }

  onChangeEndTime(time) {
    let log = Object.assign({}, this.state.service_log)
    log.endTime = time
    this.setState({
      service_log: log,
    })

  }

  onChangeScheduledAt(date) {
    let log = Object.assign({}, this.state.service_log)
    log.scheduled_at = date
    this.setState({
      service_log: log,
    })

  }

  onChangeAssignedTo(user) {
    let log = Object.assign({}, this.state.service_log)
    if(user){
      user.element = null
    }
    log.assigned_to = user
    this.setState({
      service_log: log,
    })

  }

  onChangeImageGroup(image_group) {
    this.setState({image_group: image_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(input) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = input.target.checked
    this.setState({note_obj: note_obj});
  }

  onChangeRoom(room) {
    let log = Object.assign({}, this.state.service_log)
    log.room = room
    this.setState({
      service_log: log,
    })
  }

  onChangeTextInput(e) {
    let log = Object.assign({}, this.state.service_log)
    log.description = e.target.value
    this.setState({
      service_log: log,
    })
  }

  onChangeStatus(e) {

    let log = Object.assign({}, this.state.service_log)
    log.status = e.target.value
    this.setState({
      service_log: log,
    })
  }

  updateNoteCount(count) {
    this.setState({note_count: count})
  }

  onChangeActiveTab(name) {
    this.setState({
      active_tab: name,
    });
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

  setRoom() {
    var room = null
    if (this.props.service_log.room) {
      room = this.props.service_log.room
    } else if (this.props.service_log.room_group) {
      room = this.props.service_log.room_group
    } else if (this.props.reservation_segment) {
      if (this.props.reservation_segment.room) {
        room = this.props.reservation_segment.room
      } else if (this.props.reservation_segment.room_group) {
        room = this.props.reservation_segment.room_group
      }
    }

    return room
  }

}

export default ServiceLogBuilder
